<template>
 <div>
   <div class="order-wrap" v-if="data.length>0">
     <el-card class="order-card horizontal-copy">
       <div v-for="item in data" :key="item.id" class="order-item">
         <span>{{item.source}}  </span>
         <span>{{item.xhname}}  </span>
         <span>{{item.num}}套  </span>
         <span>{{item.price}}</span>
       </div>
     </el-card>
     <el-card class="order-card horizontal-copy">
       <div v-for="item in data" :key="item.id" class="order-item">
         <span>{{item.source}}  </span>
         <span>{{item.xhname}}  </span>
         <span>{{item.num}}套</span>
       </div>
     </el-card>
     <el-card class="order-card vertical-copy">
       <div class="table-fake">
         <div class="col">
           <div v-for="item in data" :key="item.id" class="col-item">{{ item.source }}</div>
         </div>
         <div class="col">
           <div v-for="item in data" :key="item.id" class="col-item">{{ item.xhname }}</div>
         </div>
         <div class="col">
           <div v-for="item in data" :key="item.id" class="col-item">{{ item.num }}套</div>
         </div>
         <div class="col">
           <div v-for="item in data" :key="item.id" class="col-item">{{ item.price }}</div>
         </div>
       </div>
     </el-card>
   </div>
   <el-empty :image-size="200" v-else></el-empty>
 </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  name: 'order',
  components: {},
  props: {
    data: {
      type: Array,
      default() {return []}
    }
  },
  setup(props, { emit }) {

    return {

    }
  }
})
</script>
<style lang="scss" scoped>
.order-wrap {
  width: 95%;
  margin: 0 auto;
  /* 横向展示并复制：一行拼接成一句话 */
  .horizontal-copy .order-item span {
    display: inline;
    margin-right: 8px;
    white-space: nowrap;
  }

  /* 竖向展示并复制：正常换行 */
  .vertical-copy .order-item span {
    display: block;
    margin-bottom: 4px;
  }
  .order-card {
    margin-bottom: 20px;
    .order-item {
      user-select: text; /* 允许复制 */
      margin-bottom: 8px;
      span {
        margin: 0 40px;
      }
    }
  }
}

.table-fake {
  width: 85%;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
}

.col {
  display: flex;
  flex-direction: column;
  user-select: text;
  white-space: pre;
  .col-item {
    margin: 5px 0;
  }
}



</style>
